import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { Edit, Plus, Trash2 } from "lucide-react";

const AdminPosts = () => {
  const [posts, setPosts] = useState([]);

  const loadPosts = async () => {
    try {
      const res = await api.get("/posts?limit=100");
      setPosts(res.data.items);
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const deletePost = async (id) => {
    if (!window.confirm("Delete this post?")) return;

    try {
      await api.delete(`/posts/${id}`);
      toast.success("Post deleted");
      loadPosts();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    loadPosts();
  }, []);

  return (
    <section>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-black text-[#0b6b1d]">Posts</h1>
          <p className="text-slate-500">Manage news, press releases and blog posts.</p>
        </div>

        <Link
          to="/admin/posts/add"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-[#0b6b1d] text-white font-bold hover:bg-[#ff6600]"
        >
          <Plus size={18} />
          Add Post
        </Link>
      </div>

      <div className="bg-white rounded-3xl border shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-slate-50">
              <tr>
                <th className="p-4">Title</th>
                <th className="p-4">Status</th>
                <th className="p-4">Views</th>
                <th className="p-4">Date</th>
                <th className="p-4 text-right">Action</th>
              </tr>
            </thead>

            <tbody>
              {posts.map((post) => (
                <tr key={post.id} className="border-t">
                  <td className="p-4 font-bold">{post.title}</td>
                  <td className="p-4">
                    <span className="px-3 py-1 rounded-full text-xs bg-[#0b6b1d]/10 text-[#0b6b1d] font-bold">
                      {post.status}
                    </span>
                  </td>
                  <td className="p-4">{post.views}</td>
                  <td className="p-4 text-sm text-slate-500">
                    {post.created_at?.slice(0, 10)}
                  </td>
                  <td className="p-4">
                    <div className="flex justify-end gap-2">
                      <Link
                        to={`/admin/posts/edit/${post.id}`}
                        className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center"
                      >
                        <Edit size={16} />
                      </Link>

                      <button
                        onClick={() => deletePost(post.id)}
                        className="w-9 h-9 rounded-xl bg-red-50 text-red-600 flex items-center justify-center"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {posts.length === 0 && (
                <tr>
                  <td className="p-6 text-center text-slate-500" colSpan="5">
                    No posts yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default AdminPosts;